import { Grid, IconButton as MuiIconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AdornmentContainer = styled(Grid)({
  display: "flex",
});

export const IconButton = styled(MuiIconButton, {
  shouldForwardProp: (prop) => prop !== "visible",
})<{ visible: boolean }>(
  {
    visibility: "hidden",
    opacity: 0,
    transition: "all .3s ease",

    "& > svg": {
      fontSize: ".8em",
    },
  },
  ({ visible }) => ({
    ...(visible && {
      visibility: "visible",
      opacity: 1,
    }),
  })
);
